import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { Bundle } from '_core/util';
import { changePasswordApi as API } from '../Apis';

export const ChangePasswordDocs: IDocs = {
  title: 'ChangePassword',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.changePassword',
};

const prepareCall = (stateRequestParameters: any) =>
  API.call.put({
    password: stateRequestParameters.password,
    currentPassword: stateRequestParameters?.currentPassword,
  });

const handleSucessFinalResponseFunction = (data: any) => {
  Bundle.clearValue('smilesToken');
  return data;
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesInvalidPassword = infos?.invalidPassword;
  const smilesErrorService = !smilesInvalidPassword;

  return { smilesInvalidPassword, smilesErrorService };
};

export const ChangePasswordMachine = GenericMachine(
  prepareCall,
  {
    docs: ChangePasswordDocs,
    definitions: API.definitions,
  },
  {
    handleSucessFinalResponseFunction,
    handleErrorFlowFinalResponseFunction,
  },
);
